/*    
<summary>
  This functional component "ChangeLoggedInUserPassword" defines the props like initial values and functions for the child form 
  component.
  Developer:Aashish Singh, Created Date:05-Sept-2023
</summary>
<returns>Returns JSX</returns>
*/

import { observer } from "mobx-react";
import React, { useEffect } from "react";
import toast from "react-hot-toast";
import { AuthType } from "../../../constants/enums/auth-type-enum";
import { useStore } from "../../../contexts/store-provider";
import { formatMessage } from "../../../translations/format-message";
import ChangePasswordAuthForm from "../password-reset/change-password-auth-form";
import { getTokenFromLocalStorage } from "../../../helpers/localstorage-helper";
import ResetPasswordWindowPopup from "../../../shared-components/popup/confirm/reset-password-window-popup";
import ResetPasswordWindowPopupHOC from "../../../shared-components/popup/change-password/reset-password-window-popup-hoc";
import { useHistory } from "react-router-dom";
import RoutesConstants from "../../../shared-components/routes/routes-constants";

let ChangePasswordAuth: React.FC<any> = (props) => {
  const { userStore, authStore } = useStore();
  const history = useHistory();
  const {
    ResetPasswordAuthLinkService,
    resetPasswordAuthLinkState,
    resetResetPassowrdAuthLinkState,
    logout
  } = authStore;

  /**
   * The useEffect Hook lets you perform side effects in function component.
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "changePasswordSuccess" of the useEffect changed.
   */
  useEffect(() => {
    if (resetPasswordAuthLinkState.success) {
      // toast.success(formatMessage("password_reset_link_sent"));
      props.resetPasswordToggleHandler();
      resetResetPassowrdAuthLinkState();
    }
  }, [resetPasswordAuthLinkState.success]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "changePasswordError" of the useEffect changed.
   */
  useEffect(() => {
    if (resetPasswordAuthLinkState.error) {
      toast.error(formatMessage(resetPasswordAuthLinkState.error));
      resetResetPassowrdAuthLinkState();
    }
  }, [resetPasswordAuthLinkState.error]);

  /**
   * This function changes the user password by provides new password and user Id  to "chagePassword" store funtion that
   * send the request to Api.
   */
  const onSubmitForm = (values: any) => {
    ResetPasswordAuthLinkService({
      Email: values.Email,
      AuthType: AuthType.PasswordResetLinkAuth,
    });
  };

  return (
    <React.Fragment>
          {props.showResetPasswordPopup && (
        <ResetPasswordWindowPopup
          modalClosed={() => {
            history.push(RoutesConstants.CustomerLogin);
          }}
          title={formatMessage("reset_password")}
          message={formatMessage("password_reset_link_sent")}
          isLoading={false}
        />
      )}


    <ChangePasswordAuthForm
      initialValues={{
        Email: "",
      }}
      submitHandler={onSubmitForm}
      loading={resetPasswordAuthLinkState.inProgress}
    />
    </React.Fragment>
  );
};

export default ResetPasswordWindowPopupHOC(observer(ChangePasswordAuth));
